import { z } from 'zod'

export const forgottenPasswordSchema = z.object({
  email: z.string().min(1, 'Ce champ est requis').email('Veuillez saisir une adresse email valide'),
})

